import { useInviteLinksStore } from '@/features/analytics/model'
import { ORDMarkingFormData } from '@synapex/prisma/client'
import { toast } from 'react-toastify'

export function useContractValidation(markingFormData: ORDMarkingFormData) {
    const { setPublisherError, setPublishOptionError } = useInviteLinksStore()

    function validatePublisherAndPublishOption(): boolean {
        if (!markingFormData.publisher_flag) {
            setPublisherError(true)
            toast.error('Сначала выберите рекламо-распространителя')
            return false
        }

        if (!markingFormData.publish_option_flag) {
            setPublishOptionError(true)
            toast.error('Сначала выберите опцию публикации')
            return false
        }

        return true
    }

    function validateOrdContragentId(): boolean {
        if (!markingFormData.ord_contragent_id) {
            toast.error('Сначала выберите рекламо-распространителя')
            return false
        }
        return true
    }

    function validateDraftContract(): boolean {
        if (!markingFormData.draft_contract_id) {
            toast.error('Сначала выберите договор')
            return false
        }
        return true
    }

    return {
        validatePublisherAndPublishOption,
        validateOrdContragentId,
        validateDraftContract,
    }
}

